import { createApp } from 'vue'
import App from './App.vue'
import { Popper } from "vue-use-popperjs";
import { applyPolyfills, defineCustomElements } from '@universityofbristol/site-search/loader';

// Bind the custom elements to the window object
applyPolyfills().then(() => {
    defineCustomElements();
});

// Create Vue application
const app = createApp(App);

// Register popper component for tooltips
app.component('Popper', Popper);

// Mount application
app.mount('#accommodation-residences')